let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4aQQ8")).then(() => parcelRequire('aT4mQ'));